var exports = {
  "c": "StatusIndicator.module__displayBlock___Zk1TT2",
};

module.exports = exports;
